/**
 * Authenticated app shell: fixed Navbar beside a scrollable content area.
 * Rendered as a parent route so child pages mount into <Outlet>.
 */
import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';

export default function Layout() {
  return (
    <div style={styles.shell}>
      <Navbar />
      <div style={styles.content} className="layout-content">
        <Outlet />
      </div>
    </div>
  );
}

const styles = {
  shell: {
    display: 'flex',
    height: '100vh',
    overflow: 'hidden',
    background: 'linear-gradient(to bottom, var(--color-frost) 0%, var(--color-mint-dark) 100%)',
  },
  content: {
    flex: 1,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
};
